import axios from "axios";
import { msalInstance } from "../index.js";
import jwt_decode from "jwt-decode";
const apiInstance = axios.create({
  // baseURL: `${atob(config.apiEndPoint)}` ,

  timeout: 40000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor
apiInstance.interceptors.request.use(
  async (config) => {
    let token = await getToken(config);
    let access_decode = jwt_decode(token.accessToken);
    let fnKey = null;
    try {
      const fnKeyStr = localStorage.getItem("fnKey");
      fnKey = fnKeyStr && fnKeyStr !== "undefined" && fnKeyStr !== "null"
          ? atob(fnKeyStr)
          : null;
    } catch (error) {
      console.error("Invalid fnKey in localStorage", error);
      fnKey = null;
    }
    if (token) {
      config.headers = {
        Authorization: "Bearer " + token.accessToken,
        "Authorization-Id": token.idToken,
        "User-Email": btoa(
          access_decode.email ? access_decode.email : access_decode.unique_name
        ),
        Application: btoa(token.application),
        "Session-Id": token.sessionId,
        ...(fnKey ? { "x-functions-key": fnKey } : {})
      };
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const getToken = async (config) => {
  const account = msalInstance.getAllAccounts()[0];
  const accessTokenRequest = {
    scopes: ["User.Read"],
    account: account,
  };

  const token = await msalInstance
    .acquireTokenSilent(accessTokenRequest)
    .then(function (accessTokenResponse) {
      // Acquire token silent success
      let accessToken = accessTokenResponse.accessToken;
      let idToken = accessTokenResponse.idToken;
      let sessionId = accessTokenResponse.account.idTokenClaims.sid;
      let application = accessTokenResponse.account.idTokenClaims.aud;
      let tokens = {
        accessToken,
        idToken,
        sessionId,
        application,
      };
      localStorage.setItem("access_token", accessToken);
      localStorage.setItem("application", application);
      config.baseURL = atob(localStorage.getItem("apiEndpoint"));
      return tokens;
      // Call your API with token
    })
    .catch(function (error) {
      //Acquire token silent failure, and send an interactive request
      if (error) {
        msalInstance
          .acquireTokenPopup(accessTokenRequest)
          .then(function (accessTokenResponse) {
            // Acquire token interactive success
            let accessToken = accessTokenResponse.accessToken;
            let idToken = accessTokenResponse.idToken;
            let sessionId = accessTokenResponse.account.idTokenClaims.sid;
            let application = accessTokenResponse.account.idTokenClaims.aud;
            let tokens = {
              accessToken,
              idToken,
              sessionId,
              application,
            };
             config.baseURL = atob(localStorage.getItem("apiEndpoint"));
            return tokens;
            // Call your API with token
          })
          .catch(function (error) {
            // Acquire token interactive failure
            console.log("reauth failed", error);
            if (window.self !== window.top) {
              msalInstance.loginPopup({ scopes: ["User.Read"] })
                .then(loginResponse => {
                  // Login completed successfully
                  // You can now proceed to acquire tokens or continue your flow
                  console.log("Login completed 3", loginResponse);
                })
                .catch(loginError => {
                  // Handle login error
                  console.log("Login failed", loginError);
                  
                });
            } else {
              msalInstance.loginRedirect({ scopes: ["User.Read"] });
            }
          });
      }
      console.log(error);
    });
  config.baseURL = atob(localStorage.getItem("apiEndpoint"));
  return token;
};

export default apiInstance;
